export default "__VITE_ASSET__bNyzWTo3__"